import { defineMessages } from "react-intl"

export const WIX_FORM_COMPONENT_MESSAGES = defineMessages({
    saveBtn: {
        id: "integration.form.wix.save_btn",
        defaultMessage: "Save"
    },
    deleteBtn: {
        id: "integration.form.wix.delete_btn",
        defaultMessage: "Delete integration"
    },
    cancelBtn: {
        id: "integration.form.wix.cancel_btn",
        defaultMessage: "Cancel"
    }
})


// WEBPACK FOOTER //
// ./src/utils/integration/wix/messages.ts